// The Consiliul local module inside the DocFlow shell (Codul administrativ — OUG nr. 57/2019; Legea nr. 52/2003): the draft decisions,
// the meetings of the council (agenda, convocation, attendance, votes), the decisions (HCL) and the mayor's dispositions, the councillors
// and the committees (#/consiliu/...). For the secretary general, the mayor, the councillors and the departments that draft projects.
import React, { useEffect, useState } from 'react';
import { api } from '../api';
import { navigate, useAuth } from '../store';
import { Icon } from '../ui/Icon';
import { isClMember } from './types';
import { ActsPage, CouncilPage, ProjectsPage, SessionsPage, SettingsPage, TasksPage } from './Pages';
import { ProjectPage } from './Project';
import { SessionPage } from './Session';
import { ActPage } from './Act';

export function hasConsiliu(roles: string[]) { return isClMember(roles); }

export const CL_TITLES: Record<string, string> = { tasks: 'De făcut — consiliul local', projects: 'Proiecte de hotărâri', project: 'Proiect de hotărâre', sessions: 'Ședințele consiliului local',
  session: 'Ședința consiliului local', acts: 'Hotărâri și dispoziții', act: 'Act administrativ', council: 'Consilieri și comisii', settings: 'Setări consiliul local' };

type NavItemFn = (p: { icon: string; label: string; active: boolean; onClick: () => void; count?: number; alert?: boolean; title?: string }) => React.ReactElement;

export function ClNav({ page, NavItem }: { page: string; NavItem: NavItemFn }) {
  const { isAdmin } = useAuth();
  const [b, setB] = useState({ todo: 0, high: 0 });
  useEffect(() => {
    const load = () => api.get<any>('/api/consiliu/dashboard').then(d => setB({ todo: d.todo.length, high: d.todo.filter((t: any) => t.severity === 'HIGH').length })).catch(() => {});
    load();
    window.addEventListener('cl:changed', load);
    return () => window.removeEventListener('cl:changed', load);
  }, []);
  return <>
    <div className="nav-section">Lucru</div>
    <NavItem icon="check" label="De făcut" count={b.todo || undefined} alert={b.high > 0} active={page === 'tasks'} onClick={() => navigate('/consiliu/tasks')} />
    <NavItem icon="clipboard" label="Proiecte de hotărâri" active={page === 'projects' || page === 'project'} onClick={() => navigate('/consiliu/projects')} />
    <NavItem icon="calendar" label="Ședințe" active={page === 'sessions' || page === 'session'} onClick={() => navigate('/consiliu/sessions')} />
    <NavItem icon="book" label="Hotărâri și dispoziții" active={page === 'acts' || page === 'act'} onClick={() => navigate('/consiliu/acts')} />
    <NavItem icon="users" label="Consilieri și comisii" active={page === 'council'} onClick={() => navigate('/consiliu/council')} />
    <div className="nav-section">Evidențe</div>
    <NavItem icon="report" label="Rapoarte" active={page === 'reports'} onClick={() => navigate('/reports?m=CL')} />
    <NavItem icon="globe" label="Monitorul Oficial Local" title="Paginile publice: hotărâri, dispoziții, consultări publice" active={false} onClick={() => window.open('/portal/#/hotarari', '_blank')} />
    <NavItem icon="users" label="Delegări" active={page === 'delegations'} onClick={() => navigate('/delegations')} />
    {isAdmin && <><div className="nav-section">Configurare</div><NavItem icon="settings" label="Setări consiliul local" active={page === 'settings'} onClick={() => navigate('/consiliu/settings')} /></>}
  </>;
}

export function ClContent({ parts }: { parts: string[] }) {
  const { isAdmin, user } = useAuth();
  const page = parts[1] || 'tasks';
  useEffect(() => { if (!parts[1]) navigate('/consiliu/tasks'); }, [parts[1]]);
  if (!isClMember(user!.roles)) return <div className="empty"><Icon name="lock" /><h3>Modulul Consiliul local este disponibil secretarului general, primarului, consilierilor locali și compartimentelor care întocmesc proiecte</h3></div>;
  return <>
    {page === 'tasks' && <TasksPage />}
    {page === 'projects' && <ProjectsPage />}
    {page === 'project' && parts[2] && <ProjectPage key={parts[2]} id={Number(parts[2])} />}
    {page === 'sessions' && <SessionsPage />}
    {page === 'session' && parts[2] && <SessionPage key={parts[2]} id={Number(parts[2])} />}
    {page === 'acts' && <ActsPage />}
    {page === 'act' && parts[2] && <ActPage key={parts[2]} id={Number(parts[2])} />}
    {page === 'council' && <CouncilPage />}
    {page === 'settings' && isAdmin && <SettingsPage />}
  </>;
}
